<template>
  <modal :is-active="true" @close="cancel" :title="$t('configurator.modals.titles.edit_lettering')">
    <template #body>
      <div class="form-horizontal">
        <div class="form-group">
          <label class="control-label" for="label">
            {{ $t('configurator.form.labels.lettering') }}:
          </label>
          <input
            id="label"
            key="input-label"
            class="form-control input-sm"
            type="text"
            name="label"
            v-model.trim="form.label">
          <p v-if="form.errors.has('label')" class="text-danger">
            {{ $t('configurator.form.errors.lettering') }}
          </p>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-6" style="font-size: 16px; font-weight: 400;">
              {{ $t('configurator.labels.characters_inclusive') }}
            </div>
            <div class="col-sm-6 text-right">
              {{ mainStore.tmp.characters_inclusive }}
            </div>
            
            <div class="col-sm-6" style="font-size: 16px; font-weight: 400;">
              {{ $t('configurator.tables.columns.price_per_piece')}}
            </div>
            <div class="col-sm-6 text-right">
              {{ $filters.formatMoney(articlePrice) }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-6" style="font-size: 16px; font-weight: 400;">
              {{ $t('configurator.labels.price_current') }}
            </div>
            <div class="col-sm-6 text-right">
              {{ $filters.formatMoney(currentPrice) }}
            </div>
            
            <div class="col-sm-6" style="font-size: 16px; font-weight: 400;">
              {{ $t('configurator.labels.price_new') }}
            </div>
            <div class="col-sm-6 text-right" :class="{'text-danger': (newPrice > currentPrice)}">
              {{ $filters.formatMoney(newPrice) }}
            </div>
          </div>
        </div>

        <div class="form-group text-center">
          <button type="button" class="btn btn-warning mr-2" @click.prevent="cancel">
            {{ $t('configurator.buttons.cancel') }}
          </button>
          <button type="button" class="btn btn-primary" @click.prevent="submit">
            {{ $t('configurator.buttons.update') }}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import Form from '@/classes/Form'
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { useCloudStore } from '@/stores/cloud'

const mainStore = useMainStore()
const cloudStore = useCloudStore()
// define props
const props = defineProps({
  form: {
    type: Form,
    required: true,
  },
  refinement: {
    type: Object,
    required: true,
  }
})
// define emits
const emit = defineEmits(['update', 'cancel'])
// define computed props
const currentPrice = computed(() => {
  const amount = parseInt(props.refinement.amount) - parseInt(props.refinement.inclusive)

  return amount * articlePrice.value
})

const newPrice = computed(() => {
  let inclusive = 0
  if (props.form.label.trim().length >= mainStore.tmp.characters_inclusive) {
    inclusive = mainStore.tmp.characters_inclusive
  } else {
    inclusive = props.form.label.trim().length
  }
  const amount = props.form.label.trim().length - inclusive

  return amount * articlePrice.value
})

const articlePrice = computed(() => {
  return parseFloat(cloudStore.data.exhibition_prices[props.refinement.article_id].price_net)
})
// define methods
const cancel = () => {
  emit('cancel')
}

const submit = () => {
  emit('update')
}
</script>